import { createStore, applyMiddleware,combineReducers } from 'redux';
import reduxThunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'react-router-redux';
import AuthRedux from './redux/AuthRedux';
import TitleRedux from './redux/TitleRedux';
import dictionary from './redux/DictionaryRedux';
const createRootReducer = (his:any) =>
    combineReducers({
      AuthRedux,
      dictionary,
      TitleRedux
    });


const history = createBrowserHistory();
const rootReducer = createRootReducer(history);

const middleware = [reduxThunk];
const store = createStore(
  rootReducer,
  undefined,
  applyMiddleware(...middleware, routerMiddleware(history)),
);

//persistStore(store);
export { history };
export default store;
